import { createContext } from 'react'


// set the defaults
export const UserContext = createContext({
    language: "es",
    company:'01',
    setLanguage: () => { },
    setCompany: () => { }
});